import { GET_REPORT_DATA, GET_CONFERENCIAS, GET_DADOS_CHAMADA } from './mutation-types'
import relatorioDetalhadoHttpService from '../_services/relatorioDetalhadoPesquisaSatisfacaoHttpService'

export default {
  gerarDadosRelatorio: async ({ commit }, form) => {
    try {
      const response = await relatorioDetalhadoHttpService.gerarRelatorio(form)
      commit(GET_REPORT_DATA, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  gerarDadosChamada: async ({ commit }, linkedid) => {
    try {
      const response = await relatorioDetalhadoHttpService.buscarChamadaPesquisa(linkedid)
      commit(GET_DADOS_CHAMADA, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  listarConferencias: async ({ commit }) => {
    try {
      const response = await relatorioDetalhadoHttpService.getConferencias()
      commit(GET_CONFERENCIAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
